export const yesNoOptions = [
  {
    value: 'true',
    label: 'Да',
  },
  {
    value: 'false',
    label: 'Нет',
  },
]

export const identificationOptions = [
  {
    value: '',
    label: 'Все',
  },
  {
    value: 'UNIDENTIFIED',
    label: 'Нет',
  },
  {
    value: 'READY',
    label: 'В ожидании',
  },
  {
    value: 'FULL',
    label: 'Упрощенная идентификация',
  },
  {
    value: 'FULL_DOSSIER',
    label: 'Полная идентификация',
  },
  {
    value: 'FAILED',
    label: 'Ошибка',
  },
  {
    value: 'FAILED_DUE_BLACKLISTED',
    label: 'В черном списке',
  },
  {
    value: 'FAILED_DUE_INVALID_PASSPORT',
    label: 'Невалидный паспорт',
  },
  {
    value: 'SUPPORT_REVIEW',
    label: 'Проверка данных',
  },
]

export const platformOptions = [
  {
    value: '',
    label: 'Все',
  },
  {
    value: 'ANDROID',
    label: 'Android',
  },
  {
    value: 'IPHONE',
    label: 'iPhone',
  },
]